<template>
  <div class="list">
    <filterList @dropPage="dropPage"/>
    <search/>
    <viewList/>
    <pagination
      v-model="page"
      :click-handler="changePage"
      :page-count="Number(pageCount)"
      :prev-text="`<i class='material-icons'>keyboard_arrow_left</i>`"
      :next-text="`<i class='material-icons'>keyboard_arrow_right</i>`"
      :container-class="'pagination'"
    >
    </pagination>

  </div>
</template>

<script>
import FilterList from '@/components/fertilizers/bar/list/Filter'
import Search from '@/components/fertilizers/bar/list/Search'
import ViewList from '@/components/fertilizers/bar/list/ViewList'
import AppPagination from '@/components/common/AppPagination'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      // loading: false,
      page: 1,
    }
  },
  components: {
    FilterList,
    Search,
    ViewList,
    AppPagination
  },
  computed: {
    ...mapGetters({
      // id: 'fertilizers/getId',
      type: 'fertilizers/getType',
      pageCount: 'fertilizers/getPageCount',
    }),
    // validate() {
    //   return this.pageCount - this.page;
    // },
  },
  watch: {
    // type: function(val) {
    //   this.page = 1;
    // },
    // page: function(val) {
    //
    // },
  },
  methods: {
    dropPage() {
      this.changePage(1);
    },

    changePage(page) {
      this.page = page;
      this.$store.commit('fertilizers/savePage', (page - 1));
      this.$store.dispatch('fertilizers/getFertilizers');
    }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    width: 100%;
    height: 100%;
    margin-right: 8px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    border: 1px solid #E4E5E6;
    padding: 16px;
  }
</style>
